import { Box, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import useQuiosco from '../../../hooks/useQuiosco'
import useIndex from '../../../hooks/useIndex'

const LatBar = ({
    activeBar,
    setActiveBar,
    userAvatar
}) => {
    const [activeClass, setActiveClass] = useState('');
    const { userPages, handleChangeMenuOptions } = useQuiosco();
    const { auth } = useIndex();
    const currentLocation = useLocation();

    useEffect(() => {
        const width = window.innerWidth;
        width > 576 ? setActiveClass('closed') : setActiveClass('actRs');
    }, [activeBar]);

    const selectOptionMenu = (item) => {
        const width = window.innerWidth;
        handleChangeMenuOptions(item.id);
        width < 576 && setActiveBar(false);
    }

    return (
        <LateralBar id="lateralbar" className={`lateralbar ${activeBar && activeClass}`}>
            {/* TITLE */}
            <Box className="title">
                <Typography variant='h1'>Fenabocol</Typography>
                <i className="fa-solid fa-xmark" onClick={() => setActiveBar(false)}></i>
            </Box>
            {/* LATERAL USER */}
            <Box className="usrLat">
                {/* USER IMAGE */}
                <Box className="imgUstLat">
                    <img src={userAvatar} alt="user-avatar" className="imgUsrLatInt" />
                </Box>
                {/* USER DESCRIPTION */}
                <Box className="descrUser">
                    <Typography variant='h5' className="rol-cliente">{auth?.role ?? 'User'}</Typography>
                    <Typography component={'p'} className="nombre-usuario">{auth?.name ?? 'User Name'}</Typography>
                </Box>
            </Box>
            {/* LATERAL MENU */}
            <nav className="menu-lateral-princ">
                {/* LATERAL OPTIONS */}
                {userPages.map((item) => (
                    <Tooltip title={`${item.label}`} placement="right" arrow key={item.id}>
                        <Link to={`${item.link}`} onClick={() => { selectOptionMenu(item) }} className={`menu-opcion ${currentLocation?.pathname.includes(item.link) ? 'select' : ''}`}>
                            <i className={`${item.icon}`}></i><span>{`${item.label}`}</span>
                        </Link>
                    </Tooltip>
                ))}
            </nav>
        </LateralBar>
    )
}

export default LatBar

const LateralBar = styled.div`
    background: linear-gradient(180deg, #10285f 0%, #1a2f5c 48%, #0f224d 100%);
    color: #f8f4e8;
    height: 100vh;
    padding: 0;
    margin: 0;
    width: 250px;
    transition: .35s ease;
    z-index: 1000;
    overflow: hidden;
    border-right: 2px solid rgba(214, 170, 58, 0.55);
    box-shadow: 8px 0 24px rgba(0, 0, 0, 0.22);

    .title {
        width: 100%;
        min-height: 52px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        border-bottom: 1px solid rgba(214, 170, 58, 0.28);
        background: rgba(255, 255, 255, 0.035);

        h1 {
            font-size: 1.85rem;
            margin: 0;
            padding: 10px 20px;
            text-align: center;
            font-family: 'Lato';
            color: #f8f4e8;
            letter-spacing: 0.5px;
            text-transform: uppercase;
            line-height: 1;
        }

        i {
            display: none;
            color: #f8f4e8;
            cursor: pointer;
            transition: 0.25s ease;

            &:hover {
                color: #f3cd61;
                transform: scale(1.08);
            }
        }
    }

    .usrLat {
        width: 100%;
        padding: 22px 18px 18px;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .imgUstLat {
            width: 112px;
            aspect-ratio: 1/1;
            border: 3px solid rgba(214, 170, 58, 0.72);
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.08);
            overflow: hidden;
            padding: 3px;
            box-shadow: 0 8px 22px rgba(0, 0, 0, 0.24);

            img {
                margin: 0;
                padding: 0;
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 50%;
            }
        }

        .descrUser {
            width: 100%;
            margin-top: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            text-align: center;
            font-family: 'Lato';
            letter-spacing: 0.5px;

            .rol-cliente {
                margin: 0;
                color: #f3cd61;
                font-size: 0.95rem;
                font-weight: 700;
                text-transform: uppercase;
            }

            .nombre-usuario {
                padding: 0;
                margin: 4px 0 0;
                color: rgba(248, 244, 232, 0.86);
                font-size: 0.88rem;
                max-width: 190px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }

    .menu-lateral-princ {
        width: 100%;
        max-height: calc(100vh - 252px);
        margin-top: 8px;
        padding: 10px 10px 18px;
        box-sizing: border-box;
        border-top: 1px solid rgba(214, 170, 58, 0.18);
        overflow: auto;
        overflow-x: hidden;

        &::-webkit-scrollbar {
            width: 5px;
        }

        &::-webkit-scrollbar-track {
            background: rgba(255,255,255,.08);
            border-radius: 999px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: rgba(214, 170, 58, 0.7);
            border-radius: 999px;
            cursor: pointer;
        }

        .menu-opcion {
            width: 100%;
            min-height: 46px;
            padding: 0 14px;
            margin-bottom: 8px;
            box-sizing: border-box;

            color: rgba(248, 244, 232, 0.9);
            text-decoration: none;

            display: flex;
            align-items: center;
            gap: 12px;

            border-radius: 12px;
            cursor: pointer;
            font-family: 'Lato';
            letter-spacing: 0.4px;
            line-height: 1;
            font-size: 0.92rem;
            text-transform: uppercase;
            transition: 0.25s ease;

            i {
                width: 22px;
                min-width: 22px;
                margin: 0;
                font-size: 1rem;
                color: #f3cd61;
                text-align: center;
                transition: 0.25s ease;
            }

            span {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            &:hover {
                color: #fff;
                background: rgba(255, 255, 255, 0.08);
                transform: translateX(3px);
            }

            &.select {
                color: #f3cd61;
                background: rgba(214, 170, 58, 0.16);
                box-shadow: inset 0 0 0 1px rgba(214, 170, 58, 0.28);

                i {
                    color: #f3cd61;
                }
            }
        }
    }

    &.closed {
        width: 66px;

        .title {
            display: none;
        }

        .usrLat {
            padding: 12px 7px;

            .imgUstLat {
                width: 48px;
                border-width: 2px;
                padding: 2px;
                margin: 0;
            }

            .descrUser {
                display: none;
            }
        }

        .menu-lateral-princ {
            max-height: calc(100vh - 76px);
            padding: 8px 7px 14px;

            .menu-opcion {
                min-height: 46px;
                padding: 0;
                justify-content: center;
                margin-bottom: 8px;

                &:hover {
                    transform: none;
                }

                i {
                    margin: 0;
                    font-size: 1.15rem;
                }

                span {
                    display: none;
                }
            }
        }
    }

    @media (max-width: 576px) {
        position: fixed;
        top: 0;
        left: -100vw;
        max-width: 82vw;
        width: 82vw;
        z-index: 10050;
        height: 100vh;
        overflow: hidden;
        transition: left .35s ease;
        border-right: 2px solid rgba(214, 170, 58, 0.65);

        .title {
            min-height: 54px;

            h1 {
                font-size: 1.35rem;
                padding: 8px 48px 8px 18px;
            }

            i {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                font-size: 1.35rem;
                position: absolute;
                top: 50%;
                right: 16px;
                transform: translate(0, -50%);
            }
        }

        .usrLat {
            padding: 18px 16px 14px;

            .imgUstLat {
                width: 92px;
            }

            .descrUser {
                margin-top: 10px;

                .rol-cliente {
                    font-size: 0.9rem;
                }

                .nombre-usuario {
                    font-size: 0.84rem;
                    max-width: 210px;
                }
            }
        }

        .menu-lateral-princ {
            max-height: calc(100vh - 210px);
            margin-top: 4px;
            padding: 8px 12px 16px;

            .menu-opcion {
                min-height: 44px;
                margin-bottom: 7px;
                padding: 0 13px;
                font-size: 0.88rem;
                border-radius: 11px;
            }
        }

        &.actRs{
            left: 0;
        }
    }
`;